export const useApiCache = (expireTime = 60) => {
	return {
		transform(input: any) {
			// Create a custom date at which the request was sent
			return {
				...input,
				fetchedAt: new Date()
			}
		},
		getCachedData(key: any) {
			const nuxtApp = useNuxtApp()
			const data = nuxtApp.static.data[key] || nuxtApp.payload.data[key]
			// send a new request if no result is found
			if (!data) {
				return null
			}
			// Check to know if last request time is too old
			const expirationDate = new Date(data?.fetchedAt)
			// Set Time to renew the request (default: 1 min)
			expirationDate.setTime(expirationDate.getTime() + expireTime * 1000)
			const isExpired = expirationDate.getTime() < Date.now()
			// send a new request if the initial request time is expired
			if (isExpired) {
				return null
			}
			return data
		}
	}
}
